export const statusLineWrapperStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '8px',
  width: '100%',
};

export const statusLineIconStyles = {
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  height: '21px',
};

export const typeIconBrandStyles = {
  color: 'primary.main',
  display: 'flex',
};

export const typeIconErrorStyles = {
  color: 'error.main',
  display: 'flex',
};

// DEV-2951: muted tool icon for a skipped step, so the whole row reads as
// "didn't run" rather than drawing the eye with a brand-coloured glyph.
export const typeIconMutedStyles = {
  color: ({ palette }) => palette.text.disabled,
  display: 'flex',
};

export const titleStyles = {
  color: 'text.primary',
  minWidth: 0,
  flex: 1,
  overflowWrap: 'anywhere',
};

// DEV-2951: de-emphasized title for a skipped step (paired with the "Skipped"
// chip + muted icon) so it doesn't compete with steps that actually ran.
export const skippedTitleStyles = {
  ...titleStyles,
  color: 'text.secondary',
};

export const newSinceReplanLabelStyles = {
  flexShrink: 0,
};

export const activeLabelStyles = {
  flexShrink: 0,
  marginLeft: 'auto',
};

export const activeLabelInnerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
};

const baseArrowStyles = {
  display: 'flex',
  color: ({ palette }) => palette.text.secondary,
  transition: 'transform 150ms',
};

export const arrowCollapsedStyles = {
  ...baseArrowStyles,
  transform: 'rotate(-90deg)',
};

export const arrowExpandedStyles = {
  ...baseArrowStyles,
  transform: 'rotate(0deg)',
};
